<template>
    <b-modal
        id="upload-file-modal"
        ref="upload-file-modal"
        :title="$t('group.internship.upload_new_file')"
        :ok-title="$t('common.upload')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        @ok="onOk()"
        @show="onShow()"
        modal-class="apprentice-default-modal">
        <div class="file-upload">
            <b-alert show="info"
                >{{ $t('group.internship.maximum_upload_size_is') }} <span class="tex-danger">, 3000MB') </span>.
            </b-alert>

            <div class="upload-file-name">
                <b-form-group
                    :label="$t('files.file_name')"
                    label-for="upload-file-name">
                    <b-form-input
                        id="upload-file-name"
                        v-model="name"
                        required
                        :placeholder="$t('group.internship.fill_in_the_file_name')"></b-form-input>
                </b-form-group>
            </div>

            <div class="upload-file-description">
                <b-form-group
                    :label="$t('common.description')"
                    label-for="upload-file-description">
                    <b-form-input
                        id="upload-file-description"
                        v-model="description"
                        :placeholder="$t('group.internship.fill_in_a_description')"></b-form-input>
                </b-form-group>
            </div>

            <div class="upload-file-visibility">
                <b-form-group
                    :label="$t('group.internship.visibility')"
                    label-for="upload-file-visibility">
                    <b-form-select
                        class="apprentice-primary-select file-upload"
                        id="upload-file-visibility"
                        v-model="visibility"
                        :options="visibilityOptions">
                    </b-form-select>
                </b-form-group>
            </div>

            <div class="upload-file-content">
                <b-form-file
                    class="apprentice-file-upload"
                    v-model="file"
                    :state="Boolean(file)"
                    :placeholder="$t('group.internship.choose_file')"
                    drop-placeholder="Drop file here...">
                </b-form-file>

                <div class="mt-3">{{ $t('group.internship.selected_file') }} {{ file ? file.name : '' }}</div>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-group-show-upload-file-modal-component',
    props: ['groupId'],
    data() {
        return {
            name: null,
            description: null,
            file: null,
            visibility: 0,
            visibilityOptions: [
                {
                    value: 0,
                    text: this.$t('group.internship.students_and_teachers'),
                },
                {
                    value: 1,
                    text: this.$t('group.internship.only_teachers'),
                },
            ],
        };
    },
    methods: {
        onOk() {
            let formData = new FormData();
            formData.append('file', this.file);
            formData.append('description', this.description);
            formData.append('visibility', this.visibility);
            if (this.name) {
                formData.append('name', this.name);
            }
            this.alert.saving();

            const options = {
                headers: { 'Content-Type': 'multipart/form-data' },
            };
            this.axios.post(this.routes.groupFileUpload(this.groupId), formData, options).then(
                (response) => {
                    this.alert.success();
                    this.$emit('file-uploaded', response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        onShow() {
            this.name = null;
            this.description = null;
            this.file = null;
            this.visibility = 0;
        },
    },
};
</script>

<style scoped lang="scss">
.file-upload {
    margin-bottom: 0;
}

.file-upload-save {
    display: flex;
    justify-content: flex-end;
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');
}
</style>
